var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 23V18.6201L18.0701 1.55744C18.2657 1.37972 18.4817 1.24243 18.7181 1.14559C18.9547 1.04853 19.2027 1 19.4622 1C19.7217 1 19.973 1.04605 20.216 1.13815C20.4593 1.23025 20.6747 1.3767 20.8621 1.5775L22.4426 3.17768C22.6434 3.36511 22.7865 3.58079 22.8719 3.82474C22.9573 4.06868 23 4.31262 23 4.55656C23 4.81689 22.9556 5.06526 22.8667 5.30165C22.7778 5.53826 22.6365 5.75437 22.4426 5.95L5.37994 23H1ZM19.1849 6.42785L21.0588 4.56626L19.4337 2.94118L17.5721 4.81506L19.1849 6.42785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit_white.7b9057f4dfd2a84d5df4cd34b4854ea9.svg";
export { ForwardRef as ReactComponent };